import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { FeatureConfig } from './types/feature-config.interface';
import { FeatureConfigImpl } from './feature-config';
export const featureConfig = new ContainerModule(bind => {
    bind(FeatureConfig).to(FeatureConfigImpl);
});
